import ImportDataRoute from './ImportDataRoute';

export default {
  name: 'ImportDataRoute',
  location: '/lsp/import-data',
  component: ImportDataRoute,
};
